<fx-ssh-decrypt 
    *ngIf="decrypt ()" 
    [pk]="key ()" 
    [disabled]="disableDecrypt ()"
    (submit)="decryptKey ($event)" 
    (cancel)="onCancel ()"
    (error)="onDecryptError ($event)"></fx-ssh-decrypt>